// test980
(980 && 0);
